/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Box, Flex, Grid, Text } from '@chakra-ui/layout'
import { Button, HStack, IconButton, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Tab, TabList, TabPanel, TabPanels, Tabs, Textarea, useDisclosure, useToast } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { useEffect, useState } from 'react'
import { FaBrain, FaFilePdf, FaPencilAlt, FaPlus } from 'react-icons/fa'
import { MdArrowRight } from 'react-icons/md'
import { PiListPlus } from 'react-icons/pi'
import { useNavigate, useParams } from 'react-router'
import { useLocation } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { InputCmp } from '../../../components/InputCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { ModalDelete } from '../../../components/ModalDelete'
import { NavLine } from '../../../components/NavLine'
import { SelectCmp } from '../../../components/SelectCmp'
import { TextAreaCmp } from '../../../components/TextareaCmp'
import { ToggleButtonCmp } from '../../../components/ToggleButtonCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { CriterioResponse, DescricaoCargo, iAssinates, iAssinaturas, iNomeId, NivelColaborador, NivelCriterioResponse } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { formatNumberBR } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { iDescritivoInput, ModalCreate } from '../Gestao/components/ModalCreate'
import { Sidebar } from '../Gestao/components/Sidebar'
import { assinaturasParaPdf } from '../utils/assinaturas'
import { HistoricoAssinaturas } from './components/HistoricoAssinaturas'
import { HistoricoVersoes } from './components/HistoricoVersoes'
import { ModalAssinante } from './components/ModalAssinante'
import { ModalAssinanteExcluido } from './components/ModalAssinanteExcluido'
import { ModalIA } from './components/ModalIA'
import DescricaoCargoPDF from './components/RelatorioPDF'

export const CargoIndividual: React.FC = () => {
  const nav = useNavigate()
  const location = useLocation()
  const toast = useToast()
  const { id } = useParams()
  const [Cargo, setCargo] = useState<DescricaoCargo>()
  const [MudancasFeitas, setMudancasFeitas] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [Criterios, setCriterios] = useState<CriterioResponse[]>([])
  const [EditarFaixaSalarial, setEditarFaixaSalarial] = useState(false)
  const [EditarMissao, setEditarMissao] = useState(false)
  const [ModelEdit, setModelEdit] = useState<DescricaoCargo>()
  const [BaixarRelatorio, SetBaixarRelatorio] = useState(false)
  const [AssinanteExclusivoPdf, setAssinanteExclusivoPdf] = useState<iAssinates>()
  const [ModalIAIsOpen, setModalIAIsOpen] = useState(false)
  const [ModalTemMudancaIsOpen, setModalTemMudancaIsOpen] = useState(false)
  const [ModalTemMudancaVoltarIsOpen, setModalTemMudancaVoltarIsOpen] = useState(false)
  const [CargoDestinoId, setCargoDestinoId] = useState<string>()
  const [Departamentos, setDepartamentos] = useState<iNomeId[]>([])
  const urlRetorno = location.pathname + location.search
  const modalAssinante = useDisclosure()
  const modalAssinanteExcluido = useDisclosure()
  const [indiceAssinanteExcluido, setIndiceAssinanteExcluido] = useState<number>()
  const [modoEdicaoAtribuicoes, setModoEdicaoAtribuicoes] = useState<{ [key: string]: boolean }>({})
  const [textoAtribuicoes, setTextoAtribuicoes] = useState<{ [key: string]: string }>({})
  const [modoEdicaoConhecimentos, setModoEdicaoConhecimentos] = useState<{ [key: string]: boolean }>({})
  const [textoConhecimentos, setTextoConhecimentos] = useState<{ [key: string]: string }>({})
  const [modoEdicaoCompetencias, setModoEdicaoCompetenecias] = useState<boolean>(false)
  const [textoCompetencias, setTextoCompetencias] = useState<string>('')
  const [Assinaturas, setAssinaturas] = useState<iAssinaturas[]>([])
  const [deveSalvarPorqueMexeramNosAssinantes, setDeveSalvarPorqueMexeramNosAssinantes] = useState(false)
  const modalSalvarComAssinaturas = useDisclosure()
  const [enviandoParaAssinaturaNoSalvar, setEnviandoParaAssinaturaNoSalvar] = useState(false)

  function moveItem<T>(array: T[], from: number, to: number): T[] {
    const copy = [...array]
    const [item] = copy.splice(from, 1)
    copy.splice(to, 0, item)
    return copy
  }

  function updateNivelLista(
    nivelNome: string,
    campo: 'atribuicoes' | 'conhecimentosTecnicos',
    novaLista: string[]
  ): void {
    setCargo(prev => {
      if (!prev) return prev

      return {
        ...prev,
        niveis: {
          ...prev.niveis,
          [nivelNome]: {
            ...prev.niveis[nivelNome],
            [campo]: novaLista
          }
        }
      }
    })
  }

  function updateCompetencias(
    novaLista: string[]
  ): void {
    setCargo(prev => {
      if (!prev) return prev

      return {
        ...prev,
        competenciasComportamentais: novaLista
      }
    })
  }

  function adicionarAssinante(nome: string, email: string, visualizarAssinar: boolean, temCadastro: boolean): void {
    setCargo((prev) => {
      if (!prev) return prev

      return {
        ...prev,
        assinantes: [
          ...(prev.assinantes || []),
          { nome, email, visualizarAssinar, temCadastro }
        ]
      }
    })

    setDeveSalvarPorqueMexeramNosAssinantes(true)
  }

  function excluirAssinante(indice: number): void {
    setCargo((prev) => {
      if (!prev) return prev

      const assinantes = [...(prev.assinantes || [])]
      const [removido] = assinantes.splice(indice, 1)

      // Pedido de ajuste de quem saiu do fluxo nao tem mais dono para responder por ele,
      // e continuaria contando como alteracao pendente na analise
      const solicitacaoReajustes = (prev.solicitacaoReajustes ?? []).filter(
        solicitacao => solicitacao.emailSolicitante !== removido?.email
      )

      return {
        ...prev,
        assinantes: assinantes,
        solicitacaoReajustes: solicitacaoReajustes
      }
    })

    setDeveSalvarPorqueMexeramNosAssinantes(true)
  }

  function OpenModalExcluirAssinante(indice: number): void {
    setIndiceAssinanteExcluido(indice)
    modalAssinanteExcluido.onOpen()
  }

  function criarNivelVazio(): NivelColaborador {
    return {
      conhecimentosTecnicos: [''],
      habilidades: [''],
      atribuicoes: [''],
      competenciasComportamentais: [''],
      primeiroQuartil: 0,
      media: 0,
      mediana: 0,
      terceiroQuartil: 0,
      criteriosPontuacao: []
    }
  }

  function GetAssinaturas(): void {
    appApi.get(`api/Assinatura/ListarAssinaturas/${id}`)
      .then((res) => {
        setAssinaturas(res.data)
      })
      .catch(err => console.log(err))
  }

  function GetCriterios(): void {
    setIsLoading(true)

    appApi.get(`api/Criterios?cargoId=${id}`)
      .then((res) => {
        setCriterios(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function GetDescritivo(): void {
    setIsLoading(true)

    appApi.get(`api/CargosESalarios/${id}`)
      .then((res) => {
        const data: DescricaoCargo = res.data

        if (Object.keys(data.niveis).length === 0) {
          setMudancasFeitas(true)
          let niveisGerados: Record<string, NivelColaborador> = {}

          if (data.tipoNivel === 'Júnior/Pleno/Sênior') {
            niveisGerados = {
              Júnior: criarNivelVazio(),
              Pleno: criarNivelVazio(),
              Sênior: criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II e III') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II, III, IV e V') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio(),
              'Nível IV': criarNivelVazio(),
              'Nível V': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'Único') {
            niveisGerados = {
              Único: criarNivelVazio()
            }
          }

          data.niveis = niveisGerados
        }

        Object.keys(data.niveis).forEach((nivelNome) => {
          const nivel = data.niveis[nivelNome]
          nivel.primeiroQuartil = nivel.primeiroQuartil ?? 0
          nivel.media = nivel.media ?? 0
          nivel.mediana = nivel.mediana ?? 0
          nivel.terceiroQuartil = nivel.terceiroQuartil ?? 0
        })

        setCargo(data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function PutDescritivo(newCargo: iDescritivoInput): void {
    setIsLoading(true)

    appApi.put(`api/CargosESalarios/${ModelEdit?.id}`, { ...newCargo })
      .then((res) => {
        toast({
          title: 'Cargo atualizado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        GetDescritivo()
        setModelEdit(undefined)
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
      })
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => {
        setDepartamentos(res.data)
      })
      .catch(err => console.log(err))
  }

  function AbrirCargo(cargoId: string): void {
    if (MudancasFeitas) {
      setCargoDestinoId(cargoId)
      return
    }

    nav(`/Descritivo/Cargos/${cargoId}`)
  }

  async function onSave(fluxoIA?: boolean, voltar?: boolean, irPara?: string): Promise<void> {
    if (!Cargo) return
    setIsLoading(true)

    return await appApi.put('api/CargosESalarios/Update', {
      ...Cargo,
      niveis: Object.fromEntries(
        Object.entries(Cargo.niveis).map(([key, nivel]) => [key.replaceAll(' ', '_'), nivel])
      ),
      cargosSuperiores: Cargo.cargosSuperiores ?? []
    } satisfies DescricaoCargo)
      .then((res) => {
        toast({
          title: 'Cargo atualizado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        if (fluxoIA) {
          setModalIAIsOpen(true)
        }
        if (voltar) {
          nav(-1)
        }
        if (irPara) {
          setCargoDestinoId(undefined)
          nav(`/Descritivo/Cargos/${irPara}`)
        }
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
        // Get assinaturas é importante depois do onSave para não dar falsa mensagem de token expirado
        GetDescritivo()
        GetAssinaturas()
      })
  }

  // Salvar aqui muda o documento sem passar pela tela de ajustes: sem perguntar, quem ja
  // assinou ficava com o status desatualizado, mas ninguem era avisado que precisa agir de novo
  function onClickSalvarAlteracoes (): void {
    const temAssinaturaParaConsiderar = (Cargo?.assinantes ?? []).some(a => a.status === 2 || a.status === 3)

    if (temAssinaturaParaConsiderar) {
      modalSalvarComAssinaturas.onOpen()
      return
    }

    void onSave()
  }

  function salvarSemEnviar (): void {
    if (!Cargo) return

    onSave()
      .then(async () => await appApi.post('api/CargosESalarios/SalvarSemEnviarParaAssinatura', { CargoId: Cargo.id }))
      .catch(err => console.log(err))
      .finally(() => {
        modalSalvarComAssinaturas.onClose()
        GetDescritivo()
        GetAssinaturas()
      })
  }

  function salvarEEnviarParaAssinatura (): void {
    if (!Cargo) return

    setEnviandoParaAssinaturaNoSalvar(true)
    onSave()
      .then(async () => await appApi.post('api/CargosESalarios/LiberarParaAssinar', { CargoId: Cargo.id }))
      .catch(err => console.log(err))
      .finally(() => {
        setEnviandoParaAssinaturaNoSalvar(false)
        modalSalvarComAssinaturas.onClose()
        // GetAssinaturas so traz a tabela de SolicitacaoAssinatura: sem recarregar o
        // Cargo tambem, a tag continuava com o status antigo (Cargo.assinantes em memoria)
        GetDescritivo()
        GetAssinaturas()
      })
  }

  function onGerarDados(textoApoio: string): void {
    esperarRespostaDaIA()

    // appApi.post(`api/CargosESalarios/${id as string}/GerarDados?textoApoio=${textoApoio ?? ''}`, Cargo)
    appApi.post(`api/CargosESalarios/${id as string}/GerarDados`, { textoApoio: textoApoio })
      .then((res) => {
        toast({
          title: 'Informações foram geradas com sucesso via IA',
          duration: 6000,
          status: 'success',
          position: 'top',
          isClosable: true,
          render: () => (
            <HStack bg="green.500" color="white" p={4} borderRadius="md" spacing={4}>
            <Text fontWeight="bold">
              Informações geradas com sucesso via IA
            </Text>
            <Button size="sm" colorScheme="whiteAlpha" variant="outline" onClick={() => nav(urlRetorno)}>
              Ir para o cargo
            </Button>
          </HStack>
          )
        })
        GetDescritivo()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
      })
  }

  function esperarRespostaDaIA(): void {
    setIsLoading(true)

    setTimeout(() => {
      setIsLoading(false)
      toast({
        title: 'As informações estão sendo geradas, você sera notificado quando o processo for concluído',
        duration: 4000,
        status: 'info',
        position: 'top'
      })
    }, 3000)
  }

  function reenviarEmail(assinante: iAssinates): void {
    const cadastro = {
      documentoId: id,
      nomeAssinante: assinante.nome,
      emailAssinante: assinante.email,
      colaboradorId: assinante.id
    }

    appApi.post('api/Assinatura/cadastrar', cadastro)
      .then(() => {
        toast({
          title: 'E-mail reenviado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        GetDescritivo()
        GetAssinaturas()
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    setMudancasFeitas(false)
    GetDescritivo()
    GetCriterios()
    getDepartamentos()
    GetAssinaturas()
  }, [id])

  useEffect(() => {
    if (BaixarRelatorio) {
      setTimeout(() => {
        const botao: any = document.getElementById('botaoBaixarRelatorio')
        console.log(botao.href)
        const link = document.createElement('a')
        link.href = botao.href
        const sufixo = AssinanteExclusivoPdf ? `_${AssinanteExclusivoPdf.nome.replaceAll(' ', '_')}` : ''
        link.download = `Descricao_Cargo_e_Funcao_${Cargo?.nomeCargo.replaceAll(' ', '_')}${sufixo}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        SetBaixarRelatorio(false)
        setAssinanteExclusivoPdf(undefined)
      }, 3000)
    }
  }, [BaixarRelatorio])

  // PDF exclusivo desse assinante: as demais assinaturas validas ficam de fora da
  // "VERIFICACAO DE ASSINATURAS", mesmo que o documento ja tenha sido assinado por outros
  function baixarPdfDoAssinante (assinante: iAssinates): void {
    setAssinanteExclusivoPdf(assinante)
    SetBaixarRelatorio(true)
  }

  // Adicionar e excluir assinante persistem sozinhos, sem depender do "Salvar Alterações"
  useEffect(() => {
    if (!deveSalvarPorqueMexeramNosAssinantes) return

    void onSave()
    setDeveSalvarPorqueMexeramNosAssinantes(false)
  }, [Cargo?.assinantes, deveSalvarPorqueMexeramNosAssinantes])

  return (
    <Flex justifyContent={'center'} alignItems={'self-start'} pos={'relative'} gap={'2rem'} margin={'0 auto'} pr={'2rem'}>
      {ModelEdit && <ModalCreate
        isOpen
        onClose={() => { setModelEdit(undefined) }}
        onCreate={PutDescritivo}
        modelEdit={ModelEdit}
        onReloadDeps={getDepartamentos}
        departamentos={Departamentos}
      />}
      <ModalDelete
        isOpen={ModalTemMudancaIsOpen}
        message={'Você possuí alterações não salvas nesse cargo, deseja salvar suas mudanças para seguir com o processo de geração de itens por IA?'}
        onConfirm={async () => await onSave(true)}
        onRequestClose={() => setModalTemMudancaIsOpen(false)}
        center
      />
      <ModalDelete
        isOpen={ModalTemMudancaVoltarIsOpen}
        message={'Você possuí alterações não salvas nesse cargo, deseja salvar suas mudanças antes de sair da página?'}
        onConfirm={async () => await onSave(undefined, true)}
        onRequestClose={() => setModalTemMudancaVoltarIsOpen(false)}
        center
      />
      <ModalDelete
        isOpen={CargoDestinoId !== undefined}
        message={'Você possuí alterações não salvas nesse cargo, deseja salvar suas mudanças antes de abrir o outro cargo?'}
        onConfirm={async () => await onSave(undefined, undefined, CargoDestinoId)}
        onRequestClose={() => setCargoDestinoId(undefined)}
        center
      />
      <ModalIA
        isOpen={ModalIAIsOpen}
        onClose={() => setModalIAIsOpen(false)}
        onCreate={(txt) => {
          setModalIAIsOpen(false)
          onGerarDados(txt)
        }}
      />
      <ModalAssinante setCargo={adicionarAssinante} isOpen={modalAssinante.isOpen} onOpen={modalAssinante.onOpen} onClose={modalAssinante.onClose} />
      <ModalAssinanteExcluido isOpen={modalAssinanteExcluido.isOpen} onOpen={modalAssinanteExcluido.onOpen} onClose={modalAssinanteExcluido.onClose} indiceExcluido={indiceAssinanteExcluido ?? 999} excluirAssinante={excluirAssinante} />
      <Flex
        position="sticky"
        top="0"
        left="0"
        direction="column"
        bg="white"
        transition="width 0.3s"
        width={isCollapsed ? '60px' : '220px'}
        height="100vh">
        <Sidebar isCollapsed={isCollapsed} onCollapse={setIsCollapsed} selecionado={'Cargos'}/>
      </Flex>
      <Body isLoading={IsLoading} style={{ width: '100%' }} width={'100%'}>
        {BaixarRelatorio && Cargo && <PDFDownloadLink
          document={
            <DescricaoCargoPDF
              cargo={Cargo}
              criterios={Criterios}
              assinaturas={assinaturasParaPdf(Assinaturas, AssinanteExclusivoPdf)}
            />
          }
          id='botaoBaixarRelatorio'
        >
          {() =>
            <Box pos={'absolute'}></Box>
          }
        </PDFDownloadLink>}
        <Flex flexDir={'column'} gap={'1rem'}>
          <Flex justifyContent={'space-between'}>
            <NavLine
              options={[
                {
                  nome: 'Cargos',
                  path: '/Descritivo/Cargos'
                },
                {
                  nome: Cargo?.nomeCargo ?? ''
                }
              ]}
            />
            <ButtonCmp VarColor='c6' onClick={() => { if (MudancasFeitas) { setModalTemMudancaVoltarIsOpen(true) } else { nav(-1) } }}>Voltar</ButtonCmp>
          </Flex>
          <Flex justifyContent={'space-between'}>
            <h1>Gerenciamento de cargo</h1>
          </Flex>
        </Flex>
        <Flex flexDir={'column'} gap={'1rem'} my={'1rem'}>
          <LoadingContainer loading={IsLoading} linhas={24}>
            {Cargo && (
              <WhiteContainer>
                <Flex flexDir="column" gap=".75rem">
                  <Flex justifyContent={'space-between'}>
                    <Text fontSize="2xl" fontWeight="bold">{Cargo.nomeCargo}</Text>
                    <Flex gap={'1rem'}>
                      <ButtonCmp leftIcon={<FaPencilAlt/>} OutlineColor={'Green2'} onClick={() => { setModelEdit(Cargo); setIsCollapsed(true) }}>Editar informações</ButtonCmp>
                      <ButtonCmp leftIcon={<FaFilePdf/>} OutlineColor={'Red'} isLoading={BaixarRelatorio || IsLoading} onClick={() => SetBaixarRelatorio(true)}>Gerar PDF</ButtonCmp>
                      <ButtonCmp leftIcon={<FaBrain/>} VarColor={'Rosa'} onClick={() => { if (MudancasFeitas) { setModalTemMudancaIsOpen(true) } else { setModalIAIsOpen(true) } }}>Gerar detalhes do cargo com IA</ButtonCmp>
                    </Flex>
                  </Flex>

                  <Flex flexDir={'column'} gap={'.25rem'} fontSize={'14px'} lineHeight={'18px'}>
                    <Text color={'var(--Gray3)'}>CBO: <strong>{Cargo.cbo}</strong></Text>
                    <Flex direction="column" gap=".5rem">
                      {Object.entries(Cargo.cargosFuturos || {}).map(([trilha, cargos]) => (
                        <Flex key={trilha} gap=".25rem">
                          <Text color="var(--Gray3)">{trilha}: </Text>
                          <Flex gap=".25rem" alignItems="center" flexWrap="wrap">
                            {cargos.map((cargoFuturo, idx) => (
                              <Flex key={idx} align="center" gap=".25rem" color="var(--Rosa)" fontWeight="600">
                                {idx > 0 && <MdArrowRight size={16} />}
                                {cargoFuturo.id
                                  ? <Text
                                      as="span"
                                      cursor="pointer"
                                      textDecoration="underline"
                                      _hover={{ opacity: 0.7 }}
                                      title={`Abrir o cargo ${cargoFuturo.nome}`}
                                      onClick={() => AbrirCargo(cargoFuturo.id as string)}
                                    >{cargoFuturo.nome}</Text>
                                  : <Text>{cargoFuturo.nome}</Text>}
                              </Flex>
                            ))}
                          </Flex>
                        </Flex>
                      ))}
                    </Flex>
                  </Flex>
                  <Flex flexDir={'column'} p={'1rem'} gap='4px' bg={'var(--c2)'} border={'2px solid var(--c6)'} borderRadius={'4px'} fontSize={'14px'}>
                    <Flex gap={'0.5rem'}>
                      <Text fontWeight={'bold'} fontSize={'18px'}>Missão </Text>
                      <ToggleButtonCmp value={EditarMissao} OnChange={setEditarMissao}/>
                    </Flex>
                    {EditarMissao ? <TextAreaCmp height={'6rem'} bg={'#fff'} value={Cargo.missao} OnChange={(val) => setCargo({ ...Cargo, missao: val })}/> : <Text fontWeight={'thin'}>{Cargo.missao !== '' ? Cargo.missao : 'Missão do cargo ainda não foi definida'}</Text>}
                  </Flex>

                  <Flex gap="1rem" mt="1rem" flexWrap="nowrap">
                    {Object.entries(Cargo.niveis).map(([nivelKey, nivel]) => {
                      const total = (nivel.criteriosPontuacao ?? [])
                        .map(cp => {
                          const criterio = Criterios.find(c => c.id === cp.criterioId)
                          const opcao = criterio?.niveis.find(n => n.id === cp.opcaoPontuacaoId)
                          if (criterio?.nivelMinimo && !cp.minimo) return 0
                          return opcao?.pontuacao || 0
                        })
                        .reduce((acc, val) => acc + val, 0)

                      return (
                        <Flex
                          key={nivelKey}
                          flexDir="column"
                          borderRadius=".5rem"
                          border="2px solid var(--c6)"
                          bg="var(--c2)"
                          p="1rem"
                          w="100%"
                          minW="12rem"
                          boxShadow="var(--SombraBackground)"
                          align="center"
                        >
                          <Text fontSize="14px" fontWeight="500" color="var(--Gray3)">
                            Pontuação total
                          </Text>
                          <Text fontSize="14px" fontWeight="700">
                            {nivelKey.includes('_') ? nivelKey.replaceAll('_', ' ') : nivelKey}
                          </Text>
                          <Text fontSize="24px" fontWeight="700" color="var(--Azul)">
                            {total}
                          </Text>
                        </Flex>
                      )
                    })}
                  </Flex>

                  <Tabs variant="line">
                    <TabList>
                      {Object.keys(Cargo.niveis).map((nivelNome) => (
                        <Tab key={nivelNome} bg={'#fff'} color={'var(--Gray3)'} borderBottom={'2px solid var(--Gray3)'} borderColor={'var(--Gray3)'} _selected={{ color: 'var(--Azul)', borderBottom: '2px solid var(--Azul)' }} _hover={{ color: 'var(--Azul-hover)', borderBottom: '2px solid var(--Azul-hover)' }} _focus={{ boxShadow: 'none' }}>{nivelNome.includes('_') ? nivelNome.replaceAll('_', ' ') : nivelNome}</Tab>
                      ))}
                    </TabList>

                    <TabPanels>
                      {Object.entries(Cargo.niveis).map(([nivelNome, nivel], idx) => (
                        <TabPanel key={nivelNome} border={'1px solid var(--c6)'} borderRadius={'0 0 .25rem .25rem'} borderTop={'none'} boxShadow={'var(--SombraBackground)'}>
                          <Flex flexDir="column" gap="16px">
                            <Flex flexDir={'column'} px={'1.25rem'} pt={'1rem'} pb={'1.5rem'} gap='1rem' bg={'var(--c2)'} border={'2px solid var(--c6)'} borderRadius={'4px'}>
                              <Flex gap={'0.5rem'}>
                                <Text fontWeight={600} fontSize={'18px'}>Faixa Salarial</Text>
                                <ToggleButtonCmp OnChange={(val) => { setEditarFaixaSalarial(val); setMudancasFeitas(true) }} value={EditarFaixaSalarial}/>
                              </Flex>
                              {EditarFaixaSalarial
                                ? <Flex justifyContent={'center'} width={'85%'} mx={'auto'} gap={'1.5rem'}>
                                <InputCmp
                                  InputLeftGroup='R$'
                                  label="1º Quartil"
                                  type={'number'}
                                  step="any"
                                  value={(nivel.primeiroQuartil ?? 0).toString()}
                                  OnChange={(val) => {
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, primeiroQuartil: Number(val) }
                                      }
                                    })
                                  }}
                                />
                                <InputCmp
                                  InputLeftGroup='R$'
                                  label="Média"
                                  type={'number'}
                                  step="any"
                                  value={(nivel.media ?? 0).toString()}
                                  OnChange={(val) => {
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, media: Number(val) }
                                      }
                                    })
                                  }}
                                />
                                <InputCmp
                                  InputLeftGroup='R$'
                                  label="Mediana"
                                  type={'number'}
                                  step="any"
                                  value={(nivel.mediana ?? 0).toString()}
                                  OnChange={(val) => {
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, mediana: Number(val) }
                                      }
                                    })
                                  }}
                                />
                                <InputCmp
                                  InputLeftGroup='R$'
                                  label="3º Quartil"
                                  type={'number'}
                                  step="any"
                                  value={(nivel.terceiroQuartil ?? 0).toString()}
                                  OnChange={(val) => {
                                    const valorNumerico = parseFloat(val.replace(',', '.'))
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, terceiroQuartil: isNaN(valorNumerico) ? 0 : valorNumerico }
                                      }
                                    })
                                  }}
                                />
                              </Flex>
                                : <Flex justifyContent={'center'} gap="1rem" width={'85%'} mx={'auto'}>
                                <Flex flexDir={'column'} gap={'.325rem'} alignItems={'center'} justifyContent={'center'} w={'100%'}>
                                  <Text fontSize={'14px'} color={'var(--Gray3)'}>1º Quartil</Text>
                                  <Text fontSize={'22px'} color={'var(--Azul)'}>R$ {formatNumberBR(nivel.primeiroQuartil)}</Text>
                                </Flex>
                                <Flex flexDir={'column'} gap={'.325rem'} alignItems={'center'} justifyContent={'center'} w={'100%'}>
                                  <Text fontSize={'14px'} color={'var(--Gray3)'}>Média</Text>
                                  <Text fontSize={'22px'} color={'var(--Azul)'}>R$ {formatNumberBR(nivel.media)}</Text>
                                </Flex>
                                <Flex flexDir={'column'} gap={'.325rem'} alignItems={'center'} justifyContent={'center'} w={'100%'}>
                                  <Text fontSize={'16px'} fontWeight={'700'} color={'var(--Gray3)'}>Mediana</Text>
                                  <Text fontSize={'26px'} fontWeight={'700'} color={'var(--Azul)'}>R$ {formatNumberBR(nivel.mediana)}</Text>
                                </Flex>
                                <Flex flexDir={'column'} gap={'.325rem'} alignItems={'center'} justifyContent={'center'} w={'100%'}>
                                  <Text fontSize={'14px'} color={'var(--Gray3)'}>3º Quartil</Text>
                                  <Text fontSize={'22px'} color={'var(--Azul)'}>R$ {formatNumberBR(nivel.terceiroQuartil)}</Text>
                                </Flex>
                              </Flex>}
                            </Flex>

                            <Flex flexDir="column" gap="8px">
                              <Text fontWeight="medium">Atribuições</Text>
                              {idx > 0 && (
                                <Text>Todas as atribuições do nível anterior e...</Text>
                              )}
                              {modoEdicaoAtribuicoes[nivelNome]
                                ? (
                                <Textarea
                                  value={textoAtribuicoes[nivelNome] ?? ''}
                                  onChange={(e) => {
                                    const texto = e.target.value

                                    setTextoAtribuicoes(prev => ({
                                      ...prev,
                                      [nivelNome]: texto
                                    }))

                                    setCargo(prev => {
                                      if (!prev) {
                                        return
                                      }
                                      return {
                                        ...prev,
                                        niveis: {
                                          ...prev.niveis,
                                          [nivelNome]: {
                                            ...prev.niveis[nivelNome],
                                            atribuicoes: texto.split('\n')
                                          }
                                        }
                                      }
                                    })
                                  }}
                                  placeholder="Digite uma atribuição por linha"
                                />
                                  )
                                : (
                                  <Box>
                                    {nivel.atribuicoes.map((atr, idx) => (
                                    <InputCmp
                                      mt={'4px'}
                                      mb={'4px'}
                                      key={idx}
                                      value={atr.replaceAll('_', ' ')}
                                      OnChange={(val) => {
                                        const novos = [...nivel.atribuicoes]
                                        novos[idx] = val

                                        setCargo(prev => {
                                          if (!prev) {
                                            return
                                          }
                                          return {
                                            ...prev,
                                            niveis: {
                                              ...prev.niveis,
                                              [nivelNome]: {
                                                ...prev.niveis[nivelNome],
                                                atribuicoes: novos
                                              }
                                            }
                                          }
                                        })
                                      }}
                                      OnRemove={
                                        nivel.atribuicoes.length > 1
                                          ? () => {
                                              const novos = [...nivel.atribuicoes]
                                              novos.splice(idx, 1)

                                              setCargo(prev => {
                                                if (!prev) {
                                                  return
                                                }
                                                return {
                                                  ...prev,
                                                  niveis: {
                                                    ...prev.niveis,
                                                    [nivelNome]: {
                                                      ...prev.niveis[nivelNome],
                                                      atribuicoes: novos
                                                    }
                                                  }
                                                }
                                              })
                                            }
                                          : undefined
                                      }
                                      onMoveUp={
                                        idx > 0
                                          ? () => {
                                              const novos = moveItem(nivel.atribuicoes, idx, idx - 1)
                                              updateNivelLista(nivelNome, 'atribuicoes', novos)
                                            }
                                          : undefined
                                      }
                                      onMoveDown={
                                        idx < nivel.atribuicoes.length - 1
                                          ? () => {
                                              const novos = moveItem(nivel.atribuicoes, idx, idx + 1)
                                              updateNivelLista(nivelNome, 'atribuicoes', novos)
                                            }
                                          : undefined
                                      }
                                    />
                                    ))}
                                  </Box>
                                  )}
                                  <Box display={'flex'} flexDir={'row'}>
                                    {!modoEdicaoAtribuicoes[nivelNome] && (
                                      <ButtonCmp
                                      mt={'4px'}
                                      OutlineColor="Green2"
                                      leftIcon={<FaPlus />}
                                      w="16rem"
                                      onClick={() => {
                                        setCargo({
                                          ...Cargo,
                                          niveis: {
                                            ...Cargo.niveis,
                                            [nivelNome]: {
                                              ...nivel,
                                              atribuicoes: [...nivel.atribuicoes, '']
                                            }
                                          }
                                        })
                                      }}
                                    >
                                      Adicionar Atribuição
                                    </ButtonCmp>
                                    )}
                                  <IconButton
                                    h={'30.8px'}
                                    mt={'4px'}
                                    color={'blue.400'}
                                    bgColor={'white'}
                                    border={'2px solid'}
                                    borderColor={!modoEdicaoAtribuicoes[nivelNome] ? 'blue.400' : 'red.400'}
                                    icon={<PiListPlus />}
                                    w="1rem"
                                    onClick={() => {
                                      const aberto = !!modoEdicaoAtribuicoes[nivelNome]

                                      setModoEdicaoAtribuicoes(prev => ({
                                        ...prev,
                                        [nivelNome]: !aberto
                                      }))

                                      if (!aberto) {
                                        setTextoAtribuicoes(prev => ({
                                          ...prev,
                                          [nivelNome]: nivel.atribuicoes.map(atr => atr.replaceAll('_', ' ')).join('\n')
                                        }))
                                      }
                                    } } aria-label={'Editar em bloco'}
                                    ml={'8px'}
                                    />
                                  </Box>
                            </Flex>

                            <Flex flexDir="column" gap="8px">
                              <Text fontWeight="medium">Conhecimentos Técnicos</Text>
                              {idx > 0 && (
                                <Text>Todos os conhecimentos técnicos do nível anterior e...</Text>
                              )}
                              {modoEdicaoConhecimentos[nivelNome]
                                ? (
                                <Textarea
                                  value={textoConhecimentos[nivelNome] ?? ''}
                                  onChange={(e) => {
                                    const texto = e.target.value

                                    setTextoConhecimentos(prev => ({
                                      ...prev,
                                      [nivelNome]: texto
                                    }))

                                    setCargo(prev => {
                                      if (!prev) {
                                        return
                                      }
                                      return {
                                        ...prev,
                                        niveis: {
                                          ...prev.niveis,
                                          [nivelNome]: {
                                            ...prev.niveis[nivelNome],
                                            conhecimentosTecnicos: texto.split('\n')
                                          }
                                        }
                                      }
                                    })
                                  }}
                                  placeholder="Digite um conhecimento por linha"
                                />
                                  )
                                : (
                                  <Box>
                                    {nivel.conhecimentosTecnicos.map((con, idx) => (
                                      <InputCmp
                                        mt={'4px'}
                                        mb={'4px'}
                                        key={idx}
                                        value={con}
                                        OnChange={(val) => {
                                          const novos = [...nivel.conhecimentosTecnicos]
                                          novos[idx] = val
                                          setCargo({
                                            ...Cargo,
                                            niveis: {
                                              ...Cargo.niveis,
                                              [nivelNome]: { ...nivel, conhecimentosTecnicos: novos }
                                            }
                                          })
                                        }}
                                        OnRemove={
                                          nivel.conhecimentosTecnicos.length > 1
                                            ? () => {
                                                const novos = [...nivel.conhecimentosTecnicos]
                                                novos.splice(idx, 1)
                                                setCargo({
                                                  ...Cargo,
                                                  niveis: {
                                                    ...Cargo.niveis,
                                                    [nivelNome]: { ...nivel, conhecimentosTecnicos: novos }
                                                  }
                                                })
                                              }
                                            : undefined
                                        }
                                        onMoveUp={
                                          idx > 0
                                            ? () => {
                                                const novos = moveItem(nivel.conhecimentosTecnicos, idx, idx - 1)
                                                updateNivelLista(nivelNome, 'conhecimentosTecnicos', novos)
                                              }
                                            : undefined
                                        }
                                        onMoveDown={
                                          idx < nivel.conhecimentosTecnicos.length - 1
                                            ? () => {
                                                const novos = moveItem(nivel.conhecimentosTecnicos, idx, idx + 1)
                                                updateNivelLista(nivelNome, 'conhecimentosTecnicos', novos)
                                              }
                                            : undefined
                                        }
                                      />
                                    ))}
                                  </Box>
                                  )}
                                  <Box display={'flex'} flexDir={'row'}>
                                    {!modoEdicaoConhecimentos[nivelNome] && (
                                      <ButtonCmp
                                        mt={'4px'}
                                        OutlineColor="Green2"
                                        leftIcon={<FaPlus />}
                                        w="16rem"
                                        onClick={() => {
                                          setCargo({
                                            ...Cargo,
                                            niveis: {
                                              ...Cargo.niveis,
                                              [nivelNome]: {
                                                ...nivel,
                                                conhecimentosTecnicos: [...nivel.conhecimentosTecnicos, '']
                                              }
                                            }
                                          })
                                        }}
                                      >
                                        Adicionar Conhecimento
                                    </ButtonCmp>
                                    )}
                                  <IconButton
                                    h={'30.8px'}
                                    mt={'4px'}
                                    color={'blue.400'}
                                    bgColor={'white'}
                                    border={'2px solid'}
                                    borderColor={!modoEdicaoConhecimentos[nivelNome] ? 'blue.400' : 'red.400'}
                                    icon={<PiListPlus />}
                                    w="1rem"
                                    onClick={() => {
                                      const aberto = !!modoEdicaoConhecimentos[nivelNome]

                                      setModoEdicaoConhecimentos(prev => ({
                                        ...prev,
                                        [nivelNome]: !aberto
                                      }))

                                      if (!aberto) {
                                        setTextoConhecimentos(prev => ({
                                          ...prev,
                                          [nivelNome]: nivel.conhecimentosTecnicos.map(atr => atr.replaceAll('_', ' ')).join('\n')
                                        }))
                                      }
                                    } } aria-label={'Editar em bloco'}
                                    ml={'8px'}
                                    />
                                  </Box>
                            </Flex>
                            {/* Foi conversado e a conclusão é de que Habilidades não faz parte da Arquitetura Humana */}
                            {/* <Flex flexDir="column" gap="8px">
                              <Text fontWeight="medium">Habilidades</Text>
                              {nivel.habilidades.map((hab, idx) => (
                                <InputCmp
                                  key={idx}
                                  value={hab}
                                  OnChange={(val) => {
                                    const novos = [...nivel.habilidades]
                                    novos[idx] = val
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, habilidades: novos }
                                      }
                                    })
                                  }}
                                  OnRemove={
                                    nivel.habilidades.length > 1
                                      ? () => {
                                          const novos = [...nivel.habilidades]
                                          novos.splice(idx, 1)
                                          setCargo({
                                            ...Cargo,
                                            niveis: {
                                              ...Cargo.niveis,
                                              [nivelNome]: { ...nivel, habilidades: novos }
                                            }
                                          })
                                        }
                                      : undefined
                                  }
                                />
                              ))}
                              <ButtonCmp
                                OutlineColor="Green2"
                                leftIcon={<FaPlus />}
                                w="16rem"
                                onClick={() => {
                                  setCargo({
                                    ...Cargo,
                                    niveis: {
                                      ...Cargo.niveis,
                                      [nivelNome]: {
                                        ...nivel,
                                        habilidades: [...nivel.habilidades, '']
                                      }
                                    }
                                  })
                                }}
                              >
                                Adicionar Habilidade
                              </ButtonCmp>
                            </Flex> */}
                          </Flex>
                        </TabPanel>
                      ))}
                    </TabPanels>
                  </Tabs>
                  <Flex flexDir="column" gap="1rem" w={'100%'} border={'1px solid var(--c6)'} borderRadius={'.25rem'} boxShadow={'var(--SombraBackground)'} p={'1rem'} mt={'1rem'}>
                      <Flex flexDir="column" gap="8px">
                              <Text fontWeight="medium">Competências Comportamentais</Text>
                              {modoEdicaoCompetencias
                                ? (
                                <Textarea
                                  value={textoCompetencias ?? ''}
                                  onChange={(e) => {
                                    const texto = e.target.value

                                    setTextoCompetencias(
                                      texto
                                    )

                                    setCargo(prev => {
                                      if (!prev) {
                                        return
                                      }
                                      return {
                                        ...prev,
                                        competenciasComportamentais: texto.split('\n')
                                      }
                                    })
                                  }}
                                  placeholder="Digite uma competência por linha"
                                />
                                  )
                                : (
                                  <Box>
                                    {Cargo.competenciasComportamentais?.map((value, i) => (
                                      <InputCmp
                                        mt={'4px'}
                                        mb={'4px'}
                                        key={i}
                                        value={value}
                                        OnChange={(val) => {
                                          const novos = [...Cargo.competenciasComportamentais]
                                          novos[i] = val
                                          setCargo({
                                            ...Cargo,
                                            competenciasComportamentais: novos
                                          })
                                        }}
                                        OnRemove={
                                          Cargo.competenciasComportamentais.length > 1
                                            ? () => {
                                                const novos = [...Cargo.competenciasComportamentais]
                                                novos.splice(i, 1)
                                                setCargo({
                                                  ...Cargo,
                                                  competenciasComportamentais: novos
                                                })
                                              }
                                            : undefined
                                        }
                                        onMoveUp={
                                          i > 0
                                            ? () => {
                                                const novos = moveItem(Cargo.competenciasComportamentais, i, i - 1)
                                                updateCompetencias(novos)
                                              }
                                            : undefined
                                        }
                                        onMoveDown={
                                          i < Cargo.competenciasComportamentais.length - 1
                                            ? () => {
                                                const novos = moveItem(Cargo.competenciasComportamentais, i, i + 1)
                                                updateCompetencias(novos)
                                              }
                                            : undefined
                                        }
                                      />
                                    ))}
                                  </Box>
                                  )}
                                  <Box display={'flex'} flexDir={'row'}>
                                    {!modoEdicaoCompetencias && (
                                      <ButtonCmp
                                        mt={'4px'}
                                        OutlineColor="Green2"
                                        leftIcon={<FaPlus />}
                                        w="16rem"
                                        onClick={() => {
                                          setCargo({
                                            ...Cargo,
                                            competenciasComportamentais: [...Cargo.competenciasComportamentais, '']
                                          })
                                        }}
                                      >
                                        Adicionar Competência
                                    </ButtonCmp>
                                    )}
                                  <IconButton
                                    h={'30.8px'}
                                    mt={'4px'}
                                    color={'blue.400'}
                                    bgColor={'white'}
                                    border={'2px solid'}
                                    borderColor={!modoEdicaoCompetencias ? 'blue.400' : 'red.400'}
                                    icon={<PiListPlus />}
                                    w="1rem"
                                    onClick={() => {
                                      const aberto = !!modoEdicaoCompetencias

                                      setModoEdicaoCompetenecias(!aberto)

                                      if (!aberto) {
                                        setTextoCompetencias(Cargo.competenciasComportamentais.map(atr => atr.replaceAll('_', ' ')).join('\n'))
                                      }
                                    } } aria-label={'Editar em bloco'}
                                    ml={'8px'}
                                    />
                                  </Box>
                            </Flex>
                  </Flex>
                  {Criterios && Cargo?.niveis && (
                    <Flex flexDir="column" gap="1rem" w={'100%'} border={'1px solid var(--c6)'} borderRadius={'.25rem'} boxShadow={'var(--SombraBackground)'} p={'1rem'} mt={'1rem'}>
                      <Text fontWeight="medium" fontSize={'16px'}>Critérios exigidos</Text>

                      <Flex borderRadius=".25rem" direction="column" border={'1px solid var(--c6)'}boxShadow={'var(--SombraBackground)'} fontSize={'15px'}>
                        <Grid gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`} alignItems={'center'} gap={'1rem'} px="1rem" py=".75rem" borderBottom="1px solid var(--c5)" w={'100%'} fontWeight="700" color={'var(--Gray3)'}>
                          <Flex>Competências</Flex>
                          {Object.keys(Cargo.niveis).map(nivelKey => (
                            <Flex key={nivelKey} flex="1" justify="center">{nivelKey.includes('_') ? nivelKey.replaceAll('_', ' ') : nivelKey}</Flex>
                          ))}
                        </Grid>

                     {Criterios.flatMap((criterio, i) => {
                       const criteriosParaExibir: Array<{ id: string, nome: string, niveis: NivelCriterioResponse[], minimo: boolean }> = [
                         {
                           id: criterio.id,
                           nome: `${criterio.nomeCriterio}${(criterio.niveisMinimos && criterio.niveisMinimos.length > 0) ? ' - Desejável' : ''}`,
                           niveis: criterio.niveis,
                           minimo: false
                         }
                       ]

                       if (criterio.niveisMinimos && criterio.niveisMinimos.length > 0) {
                         criteriosParaExibir.push({
                           id: criterio.id,
                           nome: `${criterio.nomeCriterio} - Mínimo`,
                           niveis: criterio.niveisMinimos,
                           minimo: true
                         })
                       }
                       return criteriosParaExibir.map((crit, j) => (
                        <Grid
                          key={`${crit.id}-${crit.nome}`}
                          gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`}
                          alignItems="center"
                          gap="1rem"
                          px="1rem"
                          py=".5rem"
                          w="100%"
                          bg={(i + j) % 2 === 0 ? 'var(--c2)' : ''}
                        >
                          <Flex fontWeight="600">{crit.nome}</Flex>

                          {Object.entries(Cargo.niveis).map(([nivelKey, nivel]) => {
                            const lista = nivel.criteriosPontuacao
                            const criterioSelecionado = lista?.find(cp => cp.criterioId === crit.id && crit.minimo === (cp.minimo === true))
                            const opcaoSelecionada = crit.niveis.find(n => n.id === criterioSelecionado?.opcaoPontuacaoId)

                            return (
                              <Flex key={nivelKey} flex="1" title={opcaoSelecionada ? `${opcaoSelecionada.pontuacao} - ${opcaoSelecionada.nome}` : undefined}>
                                <SelectCmp
                                  w="100%"
                                  placeholder="Selecionar opção"
                                  value={criterioSelecionado?.opcaoPontuacaoId || ''}
                                  OnChange={(opcaoId) => {
                                    const novosNiveis = { ...Cargo.niveis }
                                    const listaAtual = [...(novosNiveis[nivelKey].criteriosPontuacao)]
                                    const idx = listaAtual.findIndex(cp => cp.criterioId === crit.id && crit.minimo === (cp.minimo === true))
                                    if (idx >= 0) {
                                      listaAtual[idx].opcaoPontuacaoId = opcaoId
                                    } else {
                                      listaAtual.push({
                                        criterioId: crit.id,
                                        opcaoPontuacaoId: opcaoId,
                                        minimo: crit.minimo
                                      })
                                    }

                                    novosNiveis[nivelKey] = {
                                      ...novosNiveis[nivelKey], criteriosPontuacao: listaAtual
                                    }

                                    setCargo({
                                      ...Cargo,
                                      niveis: novosNiveis
                                    })

                                    setMudancasFeitas(true)
                                  }}
                                >
                                  <option value={''} disabled>Selecione uma opção</option>
                                  {crit.niveis.sort((a, b) => b.pontuacao - a.pontuacao).map(n => (
                                    <option key={n.id} value={n.id}>
                                      {n.pontuacao} - {n.nome}
                                    </option>
                                  ))}
                                </SelectCmp>
                              </Flex>
                            )
                          })}
                        </Grid>
                       ))
                     })}

                        <Grid gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`} alignItems={'center'} gap={'1rem'} borderTop="1px solid var(--c5)" px="1rem" py=".75rem" fontWeight="600">
                          <Flex flex="2">Pontuação Total</Flex>
                          {Object.entries(Cargo.niveis).map(([nivelKey, nivel]) => {
                            const total = (nivel.criteriosPontuacao ?? [])
                              .map(cp => {
                                const criterio = Criterios.find(c => c.id === cp.criterioId)
                                const opcao = criterio?.niveis.find(n => n.id === cp.opcaoPontuacaoId)
                                if (criterio?.nivelMinimo && !cp.minimo) return 0
                                return opcao?.pontuacao || 0
                              })
                              .reduce((acc, val) => acc + val, 0)

                            return (
                              <Flex key={nivelKey} flex="1" justify="center" fontWeight="700" color={'var(--Azul)'}>{total}</Flex>
                            )
                          })}
                        </Grid>
                      </Flex>
                    </Flex>
                  )}

                  {/* <InputCmp label='Aprovado por' placeholder='Preencha esse campo quando esse cargo for aprovado por alguém' OnChange={(val) => setCargo({ ...Cargo, assinadoPor: val })} value={Cargo.assinadoPor}/> */}

                  <Modal isOpen={modalSalvarComAssinaturas.isOpen} onClose={modalSalvarComAssinaturas.onClose} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                      <ModalHeader color={'blue.400'}>Salvar alterações</ModalHeader>
                      <ModalBody>
                        <Text>
                          Esse cargo já tem assinatura(s). Salvar agora vai marcá-las como <strong>desatualizadas</strong>.
                          Quer só salvar, ou já enviar uma nova versão para assinatura?
                        </Text>
                      </ModalBody>
                      <ModalFooter gap={'.75rem'}>
                        <ButtonCmp OutlineColor={'c6'} isDisabled={enviandoParaAssinaturaNoSalvar} onClick={salvarSemEnviar}>
                          Salvar sem enviar para assinatura
                        </ButtonCmp>
                        <ButtonCmp VarColor={'Green2'} isLoading={enviandoParaAssinaturaNoSalvar} onClick={salvarEEnviarParaAssinatura}>
                          Enviar para assinatura
                        </ButtonCmp>
                      </ModalFooter>
                    </ModalContent>
                  </Modal>

                  <Flex gap="8px" mt="24px" justifyContent={'end'}>
                    <ButtonCmp VarColor="Green2" isLoading={IsLoading} isDisabled={IsLoading} onClick={onClickSalvarAlteracoes}>
                      Salvar Alterações
                    </ButtonCmp>
                  </Flex>

                  <HistoricoAssinaturas
                    cargo={Cargo}
                    assinaturas={Assinaturas}
                    onAdicionar={modalAssinante.onOpen}
                    onExcluir={OpenModalExcluirAssinante}
                    onReenviar={reenviarEmail}
                    onBaixarPdf={baixarPdfDoAssinante}
                    baixandoPdfDe={BaixarRelatorio ? AssinanteExclusivoPdf?.email : undefined}
                  />

                  <HistoricoVersoes
                    cargoId={Cargo.id}
                    onFechou={() => { GetDescritivo(); GetAssinaturas() }}
                  />
                </Flex>
              </WhiteContainer>
            )}
          </LoadingContainer>
        </Flex>
      </Body>
    </Flex>
  )
}
